import Page from "./Page";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { dispatch } from "../redux/store";
import AdminTabs from "../components/admin/AdminTabs";
import useAdminAPIClient from "../api/admin/hooks/useAdminAPIClient";
import { setUserIsAdmin } from "../redux/actions/admin";

const AdminPage = () => {
  const authenticated = useSelector((state) => state.user.authenticated);
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.user.activeUser);
  const { isAdmin } = useSelector((state) => state.admin);
  const navigate = useNavigate();
  const { getAdminStatus } = useAdminAPIClient();

  useEffect(() => {
    if (!authenticated && user === null) {
      //We check specifically for null as user begins as undefined, and is set to null on auth failure
      navigate("/");
    }

    if (authenticated) {
      const checkAdminStatus = async () => {
        const statusData = await getAdminStatus();
        if (statusData?.isAdmin) {
          dispatch(setUserIsAdmin(true));
        }
        setLoading(false);
      };
      void checkAdminStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, user]);

  return (
    <Page className="admin-page" pageKey="admin">
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
          }}
        >
          <CircularProgress size={128} color="white" />
        </Box>
      ) : !isAdmin ? (
        <Typography variant="body1White">
          You are not authorized to view this page.
        </Typography>
      ) : (
        <>
          <Typography variant="pageTitleWhite" className="admin-page_title">
            Admin
          </Typography>
          <AdminTabs />
        </>
      )}
    </Page>
  );
};

export default AdminPage;
